var exports = {
  "time-label": "xf0b3b88a--d666f3--time-label",
  "relative": "xf0b3b88a--d666f3--relative",
  "absolute": "xf0b3b88a--d666f3--absolute",
};

module.exports = exports;
